interface DatadogRum {
    addAction(name: string, context?: Record<string, unknown>): void;
}

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        DD_RUM?: DatadogRum;
    }
}

/**
 * Pin the host-initialized RUM instance on `window.DD_RUM`.
 *
 * MFE bundles that import `@datadog/browser-rum` overwrite the host instance via
 * `defineGlobal`. Blocking reassignment keeps payments-mfe (and other) custom
 * actions / vitals on the `customer-portal-2` session.
 */
export function datadogGuard(instance: DatadogRum): void {
    try {
        Object.defineProperty(window, 'DD_RUM', {
            configurable: true,
            enumerable: true,
            get: () => instance,
            set: attempted => {
                // eslint-disable-next-line no-console
                console.warn('[DD_RUM guard] blocked window.DD_RUM reassignment', attempted);
                // facade enrichEvent attributes this to the offending MFE via event.service
                instance.addAction('dd-rum-reassignment-blocked');
            },
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[DD_RUM guard] failed to install', error);
    }
}
